export default "611238ff9e5e93e7.svg"